import { useState, useEffect } from "react";
import axios from "../../utils/axiosConfig";
import config from "../../config/config";

export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCategories = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${config.apiUrl}/api/categories/list`);
      if (response.data.success) {
        setCategories(response.data.data || []);
      } else {
        setError(response.data.message || "Error al cargar las categorías");
      }
    } catch (error) {
      setError(error.message || "Error al cargar las categorías");
    } finally {
      setLoading(false);
    }
  };

  const deleteCategory = async (categoryId) => {
    try {
      console.log("Enviando ID:", categoryId); // Para debugging

      const response = await axios({
        method: "post",
        url: `${config.apiUrl}/api/categories/remove`,
        data: {
          _id: categoryId, // Cambiado de 'id' a '_id' para coincidir con MongoDB
        },
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("Respuesta del servidor:", response.data); // Para debugging

      return {
        success: response.data.success || false,
        message: response.data.message || "Operación completada",
        data: response.data.data,
      };
    } catch (error) {
      console.error("Error en deleteCategory:", error); // Para debugging
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Error al eliminar la categoría",
        data: null,
      };
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return {
    categories,
    setCategories,
    loading,
    error,
    refreshCategories: fetchCategories,
    deleteCategory,
  };
};
